import { formatDate, DATE_FORMATS, getMonthName } from "@amenitiz/design-system/dist";
export function setBookingWindowValues(_ref) {
  let {
    arrivalDate,
    departureDate,
    totalGuests,
    locale,
    model
  } = _ref;
  const formattedArrivalDate = arrivalDate ? formatDate(DATE_FORMATS.EU, arrivalDate) : "";
  const formattedDepartureDate = departureDate ? formatDate(DATE_FORMATS.EU, departureDate) : "";
  const getLocalMonthName = date => getMonthName({
    locale,
    month: date.getMonth(),
    mode: model === "11" ? "short" : "long"
  });
  const arrivalDay = arrivalDate ? arrivalDate.getDate() : "";
  const arrivalMonthName = arrivalDate ? getLocalMonthName(arrivalDate) : "";
  const arrivalYear = arrivalDate ? arrivalDate.getFullYear() : "";
  const departureDay = departureDate ? departureDate.getDate() : "";
  const departureMonthName = departureDate ? getLocalMonthName(departureDate) : "";
  const departureYear = departureDate ? departureDate.getFullYear() : "";
  const inputArrival = document.getElementById("info_arrival_date");
  const inputDeparture = document.getElementById("info_departure_date");
  if (inputArrival && formattedArrivalDate) {
    inputArrival.value = formattedArrivalDate;
  }
  if (inputDeparture && formattedDepartureDate) {
    inputDeparture.value = formattedDepartureDate;
  }
  const select = document.getElementById("info_total_adult");
  if (select) {
    select.value = totalGuests;
    if (select.options) {
      const optionToSelect = Array.from(select.options).find(item => item.text === totalGuests.toString());
      if (optionToSelect) {
        optionToSelect.selected = true;
        optionToSelect.value = totalGuests;
      }
    }
  }
  const infoArrivalDay = document.getElementById("arrival_date_day");
  const infoArrivalMonth = document.getElementById("arrival_date_month");
  const infoArrivalYear = document.getElementById("arrival_date_year");
  const infoDepartureDay = document.getElementById("departure_date_day");
  const infoDepartureMonth = document.getElementById("departure_date_month");
  const infoDepartureYear = document.getElementById("departure_date_year");
  if (infoArrivalDay) {
    infoArrivalDay.textContent = arrivalDay.toString();
  }
  if (infoArrivalMonth) {
    infoArrivalMonth.textContent = infoArrivalMonth.textContent?.includes("/") ? "/ " + arrivalMonthName : arrivalMonthName;
  }
  if (infoArrivalYear) {
    infoArrivalYear.textContent = arrivalYear.toString();
  }
  if (infoDepartureDay) {
    infoDepartureDay.textContent = departureDay.toString();
  }
  if (infoDepartureMonth) {
    infoDepartureMonth.textContent = infoDepartureMonth.textContent?.includes("/") ? "/ " + departureMonthName : departureMonthName;
  }
  if (infoDepartureYear) {
    infoDepartureYear.textContent = departureYear.toString();
  }
}